module.exports = __webpack_public_path__ + "static/media/172.b0acf9c6.webp";